import { render, staticRenderFns } from "./LobbySpeakers.vue?vue&type=template&id=4ff8eab2&scoped=true&"
import script from "./LobbySpeakers.vue?vue&type=script&lang=js&"
export * from "./LobbySpeakers.vue?vue&type=script&lang=js&"
import style0 from "./LobbySpeakers.vue?vue&type=style&index=0&id=4ff8eab2&prod&scoped=true&lang=scss&"
import style1 from "./LobbySpeakers.vue?vue&type=style&index=1&id=4ff8eab2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff8eab2",
  null
  
)

export default component.exports